import React from "react"

const Checkbox = ({ selected }: { selected: boolean }) => {
    return (
        <>
            {selected ? (
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M3.33333 2.5H16.6667C16.8877 2.5 17.0996 2.5878 17.2559 2.74408C17.4122 2.90036 17.5 3.11232 17.5 3.33333V16.6667C17.5 16.8877 17.4122 17.0996 17.2559 17.2559C17.0996 17.4122 16.8877 17.5 16.6667 17.5H3.33333C3.11232 17.5 2.90036 17.4122 2.74408 17.2559C2.5878 17.0996 2.5 16.8877 2.5 16.6667V3.33333C2.5 3.11232 2.5878 2.90036 2.74408 2.74408C2.90036 2.5878 3.11232 2.5 3.33333 2.5ZM9.16917 13.3333L15.0608 7.44083L13.8825 6.2625L9.16917 10.9767L6.81167 8.61917L5.63333 9.7975L9.16917 13.3333Z"
                        fill="#6941C6"
                    />
                </svg>
            ) : (
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M3.33333 3H16.6667C16.7551 3 16.8399 3.03512 16.9024 3.09763C16.9649 3.16014 17 3.24493 17 3.33333V16.6667C17 16.7551 16.9649 16.8399 16.9024 16.9024C16.8399 16.9649 16.7551 17 16.6667 17H3.33333C3.24493 17 3.16014 16.9649 3.09763 16.9024C3.03512 16.8399 3 16.7551 3 16.6667V3.33333C3 3.24493 3.03512 3.16014 3.09763 3.09763C3.16014 3.03512 3.24493 3 3.33333 3Z"
                        fill="white"
                        stroke="#667085"
                    />
                </svg>
            )}
        </>
    )
}

export default Checkbox
